import React from "react";
import "./button.scss";

const Button = ({ text, icon, ...props }) => {
  if (icon && text) {
    return (
      <button {...props}>
        <span className={`icon icon--${icon} mr-3`}></span>
        <span className='title'>{text}</span>
      </button>
    );
  } else if (icon && !text) {
    return (
      <button {...props}>
        <span className={`icon icon--${icon}`}></span>
      </button>
    );
  } else {
    return (
      <button {...props}>
        <span className='title'>{text}</span>
      </button>
    );
  }
};

export default Button;
